import(/* webpackMode: "eager", webpackExports: ["ApplicantClientComponent"] */ "/srv/src/app/(user)/_components/client-component.tsx");
